import { render, staticRenderFns } from "./withdrawalAmount.vue?vue&type=template&id=5f2bd602&scoped=true&"
import script from "./withdrawalAmount.vue?vue&type=script&lang=js&"
export * from "./withdrawalAmount.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalAmount.vue?vue&type=style&index=0&id=5f2bd602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bd602",
  null
  
)

export default component.exports